import type { FaireThemeEntity } from "../../entity_types/theme";

export const discovery_theme_spa_day_at_home: FaireThemeEntity = {
  token: "discovery_theme_spa-day-at-home",
  type: "theme",
  retailerToken: "r_discovery",
  name: "Spa Day at Home",
  description: "Luxurious self-care for a perfect spa night",
  bgColor: "#D8E8F0",
  productTokens: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
